module.exports = __webpack_public_path__ + "static/media/botao-estudante.6b536e11.png";